module.exports = __webpack_public_path__ + "static/media/ai_worth_1.74449376.png";